import styled from "styled-components";
import { TbFidgetSpinner } from "react-icons/tb";

const Loading = () => {
    return (
      <Wrapper className="loading">
        <TbFidgetSpinner className="img" />
      </Wrapper>
    );
  };
  
  export default Loading;

  const Wrapper = styled.div`
    &.loading {
        height: calc(100vh - 68px);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 50px;
        color: var(--logo);
        padding-bottom: 100px;
    }
    .img:hover {
        transform: rotate(180deg);
        transition: transform 0.1s ease;
    }

    @keyframes rotate {
    from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    .img {
        animation: rotate 3s linear infinite;
    }
  `